module.exports = __webpack_public_path__ + "img/img-entj.1acf0cf6.jpg";